import { useEffect, useState } from 'react';
import EditBankInfo from '../../../components/Modal/EditBankInfo';
import ModalContainer from '../../../components/Modal/ModalContainer';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { useFetchData } from '../../../hooks/useFetchData';
import useModal from '../../../hooks/useModal';

function AddPayment() {
    const { modalOpen, close, open } = useModal();
    const { data, loading, error } = useFetchData("mandoub/contributions");
    const [paymentMethods, setPaymentMethods] = useState([]);
    const {auth} = useAuthContext();
    useEffect(() => {
        if (auth?.user.bankInfo) {
          setPaymentMethods([
                {
                  id: auth.user._id,
                  name: "تحويل بنكي",
                  description: "يتم تحويل الراتب مباشرة إلى حسابك المصرفي.",
                  image: "https://cdn.iconscout.com/icon/free/png-512/bank-transfer-1817143-1538011.png",
                  available: true,
                  default: false,
                  requirements: [
                    { field: "اسم البنك", example: auth.user.bankInfo.bankName },
                    { field: "اسم صاحب الحساب", example: auth.user.bankInfo.accountName },
                    { field: "رقم الحساب", example: auth.user.bankInfo.accountNumber },
                    { field: "الآيبان", example: auth.user.bankInfo.iban },
                    { field: "رمز SWIFT/BIC", example: auth.user.bankInfo.swiftCode },
                  ]
                }
              ]
          );
        }
      }, [auth]);
    
  return (
    <div className="section-card w-fit !p-6 cards">
        <ModalContainer>
        {modalOpen && (
          <EditBankInfo  
            modalOpen={modalOpen}
            handleClose={close}
            method={paymentMethods[0]}
          />
        )}
      </ModalContainer>
          <div className="df ai-stretch payments-methods-res !gap-8">
            <div className="df-c">
              <h1>وسيلة الدفع</h1>
              <div className="payment-card">
                <img src="https://cdn.iconscout.com/icon/free/png-512/bank-transfer-1817143-1538011.png" className='!object-contain' alt="ماستركارد" />
              </div>
            </div>
            <div className="df-c jc-sb">
              <div className="btn" onClick={open}>إضافة البيانات المصرفية </div>
              <div>
                <div className="text">إجمالي الدخل</div>
                <div className="bold-1 text-4xl">${data?.salaryStats.totalIncome}</div>
              </div>
              <div>
                <div className="df jc-sb text"><span>${data?.salaryStats.totalBonus}</span><span>إجمالي المكافآت</span></div>
                <div className="df jc-sb text"><span>${data?.salaryStats.totalSalary}</span><span>إجمالي الرواتب</span></div>
              </div>
            </div>
          </div>
        </div>
  )
}

export default AddPayment